/**
 * 「前の画面へ」ボタン (2026-10-30)。
 *
 * 入口から戻り先 (useReturnTo) を渡されて開いた時だけ表示し、押すと直前の画面へ 1 つ戻る。
 * 固定の戻り先を持つ「〇〇に戻る」リンク (薄い文字) と見分けられるよう、枠付きのボタンにして戻り先の名前も出す。
 */
import { Undo2 } from 'lucide-react';

import { useReturnTo } from '@/hooks/useReturnTo';

export function BackToPreviousButton() {
  const { returnTo, goBack } = useReturnTo();
  if (!returnTo) return null;

  return (
    <button
      type="button"
      onClick={goBack}
      title={`直前の画面「${returnTo.label}」に、離れた時の状態のまま戻ります`}
      className="inline-flex items-center gap-1 rounded-md border border-[var(--border)] bg-[var(--bg-surface)] px-2 py-1 text-xs font-medium text-[var(--text-secondary)] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors"
    >
      <Undo2 className="size-3.5" />
      前の画面へ
      <span className="text-[var(--text-muted)] font-normal">（{returnTo.label}）</span>
    </button>
  );
}
